import * as QuillModule from 'quill'

export const deltaToHtmlQuill = (raw: any): string => {
  try {
    // parse if it's a JSON string
    const parsed =
      typeof raw === 'string'
        ? (() => {
            try {
              return JSON.parse(raw)
            } catch {
              return raw
            }
          })()
        : raw

    const ops = parsed?.ops ?? (Array.isArray(parsed) ? parsed : null)
    if (!ops) {
      // if it's plain HTML string, return it
      return typeof parsed === 'string' ? parsed : ''
    }

    // create offscreen container
    const container = document.createElement('div')
    container.style.position = 'absolute'
    container.style.left = '-9999px'
    container.style.width = '1px'
    container.style.height = '1px'
    document.body.appendChild(container)

    // Use the imported Quill module's default export or the module itself
    const QuillCtor = (QuillModule as any).default ?? (QuillModule as any)
    if (typeof QuillCtor !== 'function') {
      throw new Error('Quill constructor not found')
    }
    const quill = new QuillCtor(container, {
      readOnly: true,
      modules: { toolbar: false },
    })
    quill.setContents({ ops })

    // Quill renders editor with .ql-editor
    const editorEl = container.querySelector('.ql-editor') ?? container

    // Normalize link targets:
    // - external URLs and PDF links should open in a new tab
    // - internal / relative links should open in the same tab
    const anchors = editorEl.querySelectorAll('a')
    anchors.forEach(a => {
      try {
        const href = a.getAttribute('href') || ''
        if (!href) return

        let isPdf = false
        let isExternal = false

        try {
          const parsed = new URL(href, document.location.href)
          isPdf = parsed.pathname.toLowerCase().endsWith('.pdf')
          isExternal = parsed.origin !== document.location.origin
        } catch (e) {
          // fallback for odd/malformed hrefs
          const low = href.toLowerCase()
          isPdf = low.split('?')[0].endsWith('.pdf')
          isExternal = low.startsWith('http') || low.includes('://')
        }

        if (isExternal || isPdf) {
          a.setAttribute('target', '_blank')
          a.setAttribute('rel', 'noopener noreferrer')
        } else {
          a.removeAttribute('target')
          a.removeAttribute('rel')
        }
      } catch (e) {
        // ignore per-anchor errors
      }
    })

    const html = editorEl.innerHTML

    // cleanup
    quill.disable?.()
    // remove Quill nodes
    document.body.removeChild(container)

    return html
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('deltaToHtmlQuill error', err)
    return ''
  }
}
